import axios from 'axios';
import _ from 'lodash';

export default axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'csrf-token': _.get(window, 'pageParams.csrfToken', null),
  },
});
